<template>
  <div class="my-coaching-menu">
    <ul>
      <li @click="moveMenu('reservation_coaching')">
        <p :class="{ active: $router.currentRoute.name == 'reservation_coaching' }">예약된 코칭</p>
      </li>
      <li @click="moveMenu('complate_coaching')">
        <p :class="{ active: $router.currentRoute.name == 'complate_coaching' }">완료된 코칭</p>
      </li>
      <li @click="moveMenu('coaching_message')">
        <p :class="{ active: $router.currentRoute.name == 'coaching_message' }">
          메세지<span>{{ unreadCount }}</span>
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "inc_menu",
  props: {},
  watch: {},
  data: () => ({
    unreadCount: 0,
    totalReceivedCount: 0,
    detailList: "",
  }),
  mounted() {
    this.detailList = setInterval(() => {
      this.getMessageCount();
    }, 100);
  },
  methods: {
    moveMenu(uri) {
      this.$router.push(uri);
      // location.href=uri;
    },
    getMessageCount() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/chat/count", { params })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            let tempCount = res.data.contentinfo;
            this.unreadCount = parseInt(tempCount.qnaUnreadCount) + parseInt(tempCount.unreadCount);
            if (this.unreadCount >= 100) {
              this.unreadCount = "99+";
            }
            this.totalReceivedCount = res.data.contentinfo.totalReceivedCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  destroyed() {
    clearInterval(this.detailList);
  },
};
</script>
